/** @file hiddenForIsolate: the nodes isolate hides (all but the selection and what hangs below it). */
import { descendantsOf } from './descendantsOf';
import type { ViewportCtx } from './viewportCtx';

const NONE: readonly string[] = [];
const memo = new WeakMap<ViewportCtx, { selection: readonly string[]; nodes: object; hidden: readonly string[] }>();

/**
 * Empty while isolate is off or nothing is selected; otherwise every document node that is neither selected nor
 * below a selected node. The same array is returned while selection and nodes are unchanged (the drawn clip is
 * memoised on it).
 */
export function hiddenForIsolate(ctx: ViewportCtx): readonly string[] {
  const s = ctx.store.getState();
  const nodes = s.puppet.doc?.puppet.nodes;
  if (!ctx.isolate || nodes === undefined || s.selection.nodes.length === 0) return NONE;
  const hit = memo.get(ctx);
  if (hit?.selection === s.selection.nodes && hit.nodes === nodes) return hit.hidden;
  const keep = new Set(s.selection.nodes.flatMap((n) => [n, ...descendantsOf(nodes, n)]));
  const hidden = Object.keys(nodes).filter((n) => !keep.has(n));
  memo.set(ctx, { selection: s.selection.nodes, nodes, hidden });
  return hidden;
}
